import React, { useState, useEffect, useRef } from "react";
import Router from "./routes";
import "./Assets/CSS/login.css";
import "./Assets/CSS/style.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import ThemeConfig from "./theme";
import { SnackbarProvider } from "notistack";
import { Button, Slide, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AuthProvider } from "./hooks/useAuth";
import { ContentProvider } from "./hooks/useContent";
import { DndContext } from "@dnd-kit/core";
import ThemeToggle from "./Components/GeneralComponents/ThemeToggle";
import ScrollToTop from "./Components/GeneralComponents/ScrollToTop";

function App() {
  const notistackRef = useRef();
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Load saved position on mount
  useEffect(() => {
    const saved = localStorage.getItem("themeTogglePosition");
    if (saved) {
      try {
        setPosition(JSON.parse(saved));
      } catch {
        // Ignore parse errors
      }
    }
  }, []);

  const handleDragEnd = (event) => {
    const { delta } = event;
    if (delta) {
      const newPosition = {
        x: position.x + delta.x,
        y: position.y + delta.y,
      };
      setPosition(newPosition);
      localStorage.setItem("themeTogglePosition", JSON.stringify(newPosition));
    }
  };

  const onClickDismiss = (key) => () => {
    if (notistackRef.current) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  return (
    <div className="App">
      <ThemeProvider defaultTheme="dark">
        <ThemeConfig>
          <DndContext onDragEnd={handleDragEnd}>
            <SnackbarProvider
              ref={notistackRef}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              TransitionComponent={Slide}
              maxSnack={3}
              action={(key) => (
                <Button
                  className="snackbar-cross-icon"
                  onClick={onClickDismiss(key)}
                  type="button"
                  sx={{ minWidth: "auto", padding: "4px" }}
                >
                  <CloseIcon />
                </Button>
              )}
            >
              <ScrollToTop />
              <AuthProvider>
                <ContentProvider>
                  <Router />
                </ContentProvider>
              </AuthProvider>
            </SnackbarProvider>
            {/* Draggable FAB-style theme toggle at bottom-right */}
            <Box
              sx={{
                position: "fixed",
                bottom: { xs: "16px", sm: "24px" },
                right: { xs: "16px", sm: "24px" },
                zIndex: 1000,
                pointerEvents: "none",
                "& > *": {
                  pointerEvents: "auto",
                },
              }}
            >
              <ThemeToggle position={position} />
            </Box>
          </DndContext>
        </ThemeConfig>
      </ThemeProvider>
    </div>
  );
}

export default App;
